/**
 * California statewide LDV VMT from published community GHG release (State row).
 * After state sync, ldv_vmt matches the sum of CA county rows — same basis as GHG inventory charts.
 */
import type { SupabaseClient } from '@supabase/supabase-js';
import { fetchCommunityGhgReleaseRows } from './communityGhgInventoryReleaseService';

export const CALIFORNIA_STATE_GEOFIPS = 6;

/** True when the selected place is California statewide inventory (geofips 6 or common state names). */
export function isCaliforniaStateInventoryLocation(
  locationName: string | null | undefined,
  geofips?: number | null
): boolean {
  if (geofips != null && Number(geofips) === CALIFORNIA_STATE_GEOFIPS) return true;
  const n = (locationName || '').trim().toLowerCase();
  return (
    n === 'california' ||
    n === 'state of california' ||
    n === 'ca' ||
    n === 'calif.'
  );
}

export interface CaliforniaStateLdvVmtRow {
  year: number;
  ldv_vmt: number;
}

/**
 * Paginated fetch of State geography_type rows for California (geofips 6).
 */
export async function fetchCaliforniaStateLdvVmtSeries(
  _client: SupabaseClient
): Promise<CaliforniaStateLdvVmtRow[]> {
  const { rows, error } = await fetchCommunityGhgReleaseRows({
    geographyType: 'State',
    geofipsIn: [CALIFORNIA_STATE_GEOFIPS],
    select: 'year,ldv_vmt',
  });
  if (error) return [];
  const out: CaliforniaStateLdvVmtRow[] = [];
  for (const r of rows) {
    if (r.ldv_vmt != null && Number.isFinite(r.year)) {
      out.push({ year: r.year, ldv_vmt: r.ldv_vmt });
    }
  }
  out.sort((a, b) => a.year - b.year);
  return out;
}
